import { template } from "lodash";

export const defaultData = {
  rcpState: "",
  addrCity: "",
  rcpGroup: "",
  boardTitle: "",
  boardContent: "",
  rcpGroupSendYn: "Y",
  pushStatus: null,
  pushType: "DIRECT",
  hasSnooze: false,
  snoozeMax: 0,
  snoozeInterval: 0,
  reserveDate: undefined,
  reserveTime: "09:00:00",
  repeatStrategy: {
    period: "DAILY",
    dayOfWeek: _.times(7, () => true)
  },
  validFrom: undefined,
  validTo: undefined
};

/*
2) 설정에 따른 Confirm 메시지
- 받는 사람 그룹 선택 & 반복소식인 경우 : 서울특별시 성동구 A그룹 어르신에게 2020년 10월 10일까지 매일 O시O분에 반복소식 전송합니다. 등록하시겠습니까?
- 받는 사람 개별 선택 & 반복소식인 경우 : 김순자님 외 10명에게 2020년 10월 10일까지 매일 O시O분에 반복소식 전송합니다. 등록하시겠습니까?

- 받는 사람 그룹 선택 & 맞춤소식인 경우 : 서울특별시 성동구 A그룹중 [생일]에 해당하는 어르신에게 매일 O시O분에 맞춤소식 전송합니다. 등록하시겠습니까?
- 받는 사람 개별 선택 & 맞춤소식인 경우 : 김순자님 외 10명중 [생일]에 해당하는 어르신에게 매일 O시O분에 맞춤소식 전송합니다. 등록하시겠습니까?

3) Confirm 결과
- 반복소식 : 반복소식 등록되었습니다.
- 맞춤소식 : [생일] 맞춤소식 등록되었습니다.
(popup.close)
*/

/*
1) 유효성 체크 alert 메세지
- 메세지 내용이 없는 경우 > 메세지 내용을 입력해주세요.
- 전송주기 요일별 선택했는데 요일을 선택 안한 경우 > 소식 전송할 요일을 선택해주세요.
- 미확인 알림 1,2,3회 선택했는데 시간 간격 설정 안한 경우 > 미확인 알림 시간 간격을 설정해주세요.

2) 설정에 따른 Confirm 메시지
- 받는 사람 그룹 선택 & 반복소식인 경우 : 서울특별시 성동구 A그룹 어르신에게 2020년 10월 10일까지 매일 O시O분에 반복소식 전송합니다. 등록하시겠습니까?
- 받는 사람 개별 선택 & 반복소식인 경우 : 김순자님 외 10명에게 2020년 10월 10일까지 매일 O시O분에 반복소식 전송합니다. 등록하시겠습니까?

- 받는 사람 그룹 선택 & 맞춤소식인 경우 : 서울특별시 성동구 A그룹중 [생일]에 해당하는 어르신에게 매일 O시O분에 맞춤소식 전송합니다. 등록하시겠습니까?
- 받는 사람 개별 선택 & 맞춤소식인 경우 : 김순자님 외 10명중 [생일]에 해당하는 어르신에게 매일 O시O분에 맞춤소식 전송합니다. 등록하시겠습니까?

3) Confirm 결과
- 반복소식 : 반복소식 수정되었습니다.
- 맞춤소식 : [생일] 맞춤소식 수정되었습니다.
(popup.close)
*/

export default {
  computed: {
    isGroupSend() {
      return this.newsData.rcpGroupSendYn === "Y";
    },
    isReadyStatus() {
      return !this.newsData.pushStatus || this.newsData.pushStatus === "WAIT";
    }
  },
  methods: {
    getTargetText() {
      switch (this.newsData.rcpGroupSendYn) {
        case "Y": {
          // 수정시엔 rcpDesc 참조
          const isEdit = !!this.newsData.id;
          if (isEdit) return this.newsData.rcpDesc;

          const groupData = this.$refs.targetSelector.getGroupFullData();
          const { org, state, city, group } = groupData;
          let cityText = `[${org.orgName}] ${state.stateName}`;
          if (city) cityText = `${cityText} ${city.cityName}`;
          const groupText = (group && group.groupName) || "전체";
          return `${cityText} ${groupText}`;
        }
        case "N": {
          const length = this.selectedRcpList.length;
          const otherText = length > 1 ? ` 외 ${length - 1}명` : "";
          return `${this.selectedRcpList[0].recipientName ||
            this.selectedRcpList[0].rcpName}님${otherText}`;
        }
        default:
          return "";
      }
    },
    getReserveDateText() {
      const date = this.newsData.reserveDate;
      const format = date.getMinutes() ? "m월d일 H시M분으로" : "m월d일 H시로";
      return this.$utils.dateformat(date, format);
    },
    getSubmitMessagesGeneral() {
      const target = this.getTargetText();
      if (this.isReadyStatus) {
        // 등록시, 전송전상태시
        switch (this.newsData.pushType) {
          case "DIRECT":
            return {
              confirm: `${target}에게\n바로 알림 전송하시겠습니까?`,
              complete: "등록되었습니다."
            };
          case "RESERVE": {
            const dateText = this.getReserveDateText();
            return {
              confirm: `${target}에게 ${dateText}\n예약전송 등록하시겠습니까?`,
              complete: "전송 예약되었습니다."
            };
          }
          default:
            return {
              confirm: `등록하시겠습니까?`,
              complete: "등록되었습니다."
            };
        }
      } else {
        return {
          confirm: `${target}에게\n보낸 소식을 수정하시겠습니까?`,
          complete: "수정 완료되었습니다."
        };
      }
    },
    getSubmitMessagesRepeat() {
      let target = this.getTargetText();
      const dateText = this.$utils.dateText(
        this.newsData.validTo.replace(" ", "T")
      );
      const strategy = this.getRepeatStrategyText(this.newsData.repeatStrategy);
      const time = this.newsData.reserveTime.slice(0, 5);
      const timeText = `${strategy} ${time}`;
      const complete = this.newsData.id
        ? "반복소식 수정되었습니다."
        : "반복소식 등록되었습니다.";
      switch (this.newsData.rcpGroupSendYn) {
        case "Y":
          return {
            confirm: `${target} 어르신에게 ${dateText}까지\n${timeText}에 반복소식 전송합니다.\n등록하시겠습니까?`,
            complete
          };
        case "N": {
          return {
            confirm: `${target}에게 ${dateText}까지\n${timeText}에 반복소식 전송합니다.\n등록하시겠습니까?`,
            complete
          };
        }
        default:
          return {
            confirm: "등록하시겠습니까?",
            complete
          };
      }
    },
    getSubmitMessagesCustom() {
      let target = this.getTargetText();
      const typeText = this.getCustomNewsText(this.newsData.customNewsType);
      // const dateText = this.$utils.dateText(this.newsData.validTo);
      const strategy = this.getRepeatStrategyText(this.newsData.repeatStrategy);
      const time = this.newsData.reserveTime.slice(0, 5);
      const timeText = `${strategy} ${time}`;
      const complete = this.newsData.id
        ? `[${typeText}] 맞춤소식 수정되었습니다.`
        : `[${typeText}] 맞춤소식 등록되었습니다.`;
      switch (this.newsData.rcpGroupSendYn) {
        case "Y":
          return {
            confirm: `${target}중\n[${typeText}]에 해당하는 어르신에게\n${timeText}에 맞춤소식 전송합니다.\n등록하시겠습니까?`,
            complete
          };
        case "N": {
          const isSingle = this.selectedRcpList.length === 1;
          return {
            confirm: isSingle
              ? `${target}이 [${typeText}]에 해당하면\n${timeText}에 맞춤소식 전송합니다.\n등록하시겠습니까?`
              : `${target}중\n[${typeText}]에 해당하는 어르신에게\n${timeText}에 맞춤소식 전송합니다.\n등록하시겠습니까?`,
            complete
          };
        }
        default:
          return {
            confirm: "등록하시겠습니까?",
            complete
          };
      }
    }
  }
};
